<template>
    <v-dialog v-model="show" :max-width="maxWidth || 350" :fullscreen="fullscreen" :transition="transition" :persistent="persistent" :scrollable="scrollable" overlay-color="#000" overlay-opacity="0.75">
        <v-card :class="{'fill-height': fullscreen}">
            <v-card-title class="mb-2">
                <v-icon v-if="titleIcon" color="strong-text" right>{{ titleIcon }}</v-icon>
                <span>{{title}}</span>
            </v-card-title>
            <v-card-subtitle v-if="subtitle">{{subtitle}}</v-card-subtitle>
            <v-card-text>
                <div class="py-0" :class="{'px-2': pcOnly && !noPadding}">
                    <slot />
                </div>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn :disabled="loading" color="muted" text @click="show = false">
                    Cancel
                </v-btn>
                <v-btn :loading="loading" :disabled="loading || disabled" :color="buttonColor || 'primary darken-1'" text @click="submitAction">
                    {{buttonText || 'Confirm'}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    props: ['value', 'data', 'url', 'action', 'successMsg', 'buttonText', 'buttonColor', 'title', 'titleIcon', 'subtitle', 'maxWidth', 'asFormData', 'scrollable', 'persistent', 'fullscreen', 'transition', 'noPadding', 'disabled', 'notValidated', 'validationMsg'],
    data(){
        return {
            show: false,
            loading: false,
        }
    },
    watch :{
        show(show){
            if (!show){
                this.$emit('input', false); // close
            }
        },
        value(show){
            this.show = show;
        }
    },
    computed: {
        ...GlobalComputed,
        actionComputed(){
            const action = this.action;
            return action === 'put' ? 'fastPutAction' : (action === 'delete' ? 'fastDeleteAction' : 'fastPostAction');
        }
    },
    methods: {
        ...GlobalMethods,
        submitAction(){
            const url = this.url;
            if (url && !this.loading){
                if (this.notValidated){
                    this.showMsg(this.validationMsg ? this.validationMsg : 'Please fill the required fields.', 'error');
                    return;
                }

                this.loading = true;

                let data = this.data;
                if (this.asFormData){
                    data = new FormData();
                    for (let property in this.data){
                        if (Array.isArray && Array.isArray(this.data[property])){
                            this.data[property].forEach(el=>{
                                data.append(property + '[]', el);
                            })
                        }else{
                            if (this.data[property] !== null && this.data[property] !== undefined){
                                data.append(property, this.data[property]);
                            }
                        }
                    }
                }

                const payload = this.data ? {url, data: data} : {url};

                this.$store.dispatch(this.actionComputed, payload).then(response=>{
                    this.loading = false;
                    this.show = false;
                    window.setTimeout(()=>{
                        this.$emit('reset');
                    }, 500);
                    const responseData = response.data.data ? response.data.data : response.data;
                    this.$emit('sync', responseData);
                    this.$emit('response', response);

                    const successMsg = this.successMsg || 'Action done successfully'
                    this.showMsg(successMsg, 'success');
                }).catch(e=>{
                    this.loading = false;
                    if (e.response && e.response.data && e.response.data.errors && Object.keys(e.response.data.errors).length){
                        const errors = e.response.data.errors;
                        let msg = errors[Object.keys(errors)[0]][0];
                        this.showMsg(msg, 'error');
                    }else{
                        if (e && e.response && [403, 401].includes(e.response.status)){
                            this.showMsg('You don\'t have permissions to perform this action', 'error');
                        }else{
                            const errorMsg = e && e.response.data ? e.response.data.message : null;
                            const msg = errorMsg || 'an error occurred during preforming your action';
                            this.showMsg(msg, 'error');
                        }
                    }

                })
            }
        }
    }
}
</script>

<style>

</style>
